import { z } from 'zod';

export const schema = z.object({
  national_record_status: z.enum(['default', 'include', 'exclude']).optional(),
  district_record_status: z.enum(['default', 'include', 'exclude']).optional(),
});

export type Schema = z.infer<typeof schema>;
